var render = function render(){
  var _vm$value, _vm$actions, _vm$value2, _vm$errors;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tablewrapper",
    "class": [_vm.className, {
      'table-compact-selection': _vm.compactSelection && _vm.showSelect,
      'table-bordered': _vm.bordered,
      'table-no-cell-padding': _vm.noCellPadding,
      'table-disable-row-hover': _vm.disableRowHover
    }]
  }, [_vm.showTableControls ? _c('v-card-text', {
    staticClass: "controls"
  }, [_c('TableControls', {
    ref: "tableControls",
    attrs: {
      "filters-conf": _vm.filtersConf,
      "filters": _vm.filters,
      "views-scope": _vm.resolvedViewsScope,
      "views-exclude-keys": _vm.viewsExcludeKeys,
      "enable-ordering": _vm.enableOrdering,
      "exclude-from-ordering": _vm.excludeFromOrdering,
      "columns": _vm.columns,
      "enable-column-management": _vm.enableColumnManagement,
      "columns-scope": _vm.resolvedColumnsScope,
      "quick-filter-count": _vm.quickFilterCount,
      "force-filters-panel-open": _vm.forceFiltersPanelOpen,
      "search-placeholder": _vm.searchPlaceholder,
      "autofocus-search": _vm.autofocusSearch
    },
    on: {
      "on-filters-change": function onFiltersChange($event) {
        return _vm.onFiltersChange($event);
      },
      "view-apply": _vm.onViewApply,
      "view-reset": _vm.onViewReset,
      "columns-state-change": _vm.onColumnsStateChange
    }
  })], 1) : _vm._e(), (_vm$value = _vm.value) !== null && _vm$value !== void 0 && _vm$value.length && (_vm$actions = _vm.actions) !== null && _vm$actions !== void 0 && _vm$actions.length ? _c('div', {
    staticClass: "table-bulk-selection-wrapper"
  }, [_c('Block', {
    staticClass: "table-bulk-selection-bar"
  }, [_c('div', {
    staticClass: "table-bulk-selection-bar__message black--text"
  }, [_c('span', [_vm._v(_vm._s(_vm.$translate("youSelected")) + " "), _c('span', {
    staticClass: "font-weight-bold"
  }, [((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : _vm$value2.length) == 1 ? [_vm._v(" 1 " + _vm._s(_vm.$translate("item")) + " ")] : [_vm._v(" " + _vm._s(_vm.value.length) + " " + _vm._s(_vm.$translate("items")))], _vm._v(". ")], 2), _vm.value.length == 1 ? [_vm._v(" " + _vm._s(_vm.$translate("selectionItemInstructions")) + " ")] : [_vm._v(" " + _vm._s(_vm.$translate("selectionItemsInstructions")) + " ")]], 2)]), _c('v-btn', {
    staticClass: "table-bulk-selection-bar__clear font-weigth-regular",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.iconName("cancel")))]), _vm._v(" " + _vm._s(_vm.$translate("clearSelection")) + " ")], 1), _c('Action', {
    staticClass: "table-bulk-selection-bar__action",
    attrs: {
      "label": _vm.$translate('selectAction'),
      "main": true,
      "items": _vm.actions,
      "loading": _vm.bulkLoading,
      "disabled": _vm.bulkLoading
    },
    on: {
      "on-action": _vm.runBulkAction
    }
  })], 1)], 1) : _vm._e(), (_vm$errors = _vm.errors) !== null && _vm$errors !== void 0 && _vm$errors.length ? _c('Placeholder', {
    attrs: {
      "title": _vm.$translate('messages.errorLoadingData'),
      "icon": "nodata",
      "description": _vm.$translate('messages.errorLoadingDataDescription'),
      "actions": [{
        text: _vm.$translate('buttons.retry'),
        action: 'retry'
      }]
    },
    on: {
      "on-action": _vm.onErrorAction
    }
  }) : _vm.showEmptyPlaceholder ? [_c('Placeholder', {
    attrs: {
      "icon": _vm.placeholderIcon,
      "title": _vm.placeholderTitle || _vm.$translate('messages.noResultFound'),
      "description": _vm.placeholderDescription || _vm.$translate('messages.noResultFoundDescription'),
      "actions": _vm.allPlaceholderActions
    },
    on: {
      "on-action": _vm.onPlaceholderAction
    }
  })] : _vm.showTableSkeleton ? _c('TableSkeleton', {
    attrs: {
      "column-count": _vm.skeletonColumnCount,
      "row-count": _vm.skeletonRowCount,
      "show-select": _vm.showSelect,
      "dense": _vm.dense,
      "show-footer": !_vm.hideDefaultFooter,
      "header-labels": _vm.skeletonHeaderLabels
    }
  }) : _vm.showDataTable ? _c('v-data-table', _vm._b({
    attrs: {
      "value": _vm.value,
      "headers": _vm.headers,
      "dense": _vm.dense,
      "mobile-breakpoint": 0,
      "items": _vm.rows || [],
      "loading": _vm.dataTableLoading,
      "page": _vm.page,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "must-sort": _vm.mustSort,
      "single-select": _vm.singleSelect,
      "disabled": false,
      "selectable-key": _vm.selectableKey,
      "item-key": _vm.itemKey,
      "item-value": _vm.itemValue,
      "show-select": _vm.showSelect,
      "items-per-page": _vm.itemsPerPage,
      "no-results-text": _vm.placeholderTitle || _vm.$translate('messages.noResultFound'),
      "no-data-text": _vm.placeholderTitle || _vm.$translate('messages.noResultFound'),
      "footer-props": _vm.tableFooterProps,
      "item-class": _vm.itemClass,
      "hide-default-footer": _vm.hideDefaultFooter,
      "hide-default-header": _vm.hideDefaultHeader
    },
    on: {
      "input": _vm.onSelectionInput,
      "item-selected": function itemSelected($event) {
        return _vm.$emit('item-selected');
      },
      "toggle-select-all": function toggleSelectAll($event) {
        return _vm.$emit('toggle-select-all');
      },
      "update:page": function updatePage($event) {
        _vm.page = $event;
      },
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:itemsPerPage": function updateItemsPerPage($event) {
        _vm.itemsPerPage = $event;
      },
      "update:items-per-page": function updateItemsPerPage($event) {
        _vm.itemsPerPage = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item,
          headers = _ref.headers,
          index = _ref.index;
        return [_c('tr', {
          key: index,
          "class": [item[_vm.itemClass], {
            pointer: _vm.clickableRow,
            'table-row--dragging': _vm.rowDragIndex === index,
            'table-row--drag-over-before': _vm.rowDragOverIndex === index && !_vm.rowDragPlaceAfter,
            'table-row--drag-over-after': _vm.rowDragOverIndex === index && _vm.rowDragPlaceAfter
          }],
          on: {
            "dragover": function dragover($event) {
              $event.preventDefault();
              return _vm.onRowDragOver($event, index);
            },
            "drop": function drop($event) {
              $event.preventDefault();
              return _vm.onRowDrop($event, index);
            },
            "dragenter": function dragenter($event) {
              $event.preventDefault();
            },
            "dragend": _vm.onRowDragEnd,
            "click": function click($event) {
              return _vm.handleRowClick($event, item);
            },
            "mouseenter": function mouseenter($event) {
              return _vm.$emit('row-mouseenter', item);
            },
            "mouseleave": function mouseleave($event) {
              return _vm.$emit('row-mouseleave', item);
            }
          }
        }, _vm._l(headers, function (header) {
          return _c('td', {
            key: header.value || header.field || header.slot,
            "class": ['mb-0 mb-sm-0', header["class"], {
              'table-compact-select-cell': _vm.compactSelection && header.value === 'data-table-select',
              'table-compact-action-cell': _vm.compactSelection && _vm.showSelect && ['catalog_entry_add', 'product_add', 'order_line_remove'].includes(header.field)
            }, {
              'table-bordered-cell': _vm.bordered,
              'sticky-column': header.sticky,
              'table-cell-wrap': header.cellWrap === true
            }],
            style: _vm.tdColumnStyle(header),
            attrs: {
              "data-no-row-click": header.value == '_rowReorder' || undefined
            }
          }, [_vm._t(header.slot || header.field, function () {
            return [header.value == '_rowReorder' ? [_c('span', {
              staticClass: "table-row-drag-handle",
              attrs: {
                "data-no-row-click": "",
                "draggable": "true"
              },
              on: {
                "click": function click($event) {
                  $event.stopPropagation();
                },
                "mousedown": function mousedown($event) {
                  $event.stopPropagation();
                },
                "dragstart": function dragstart($event) {
                  return _vm.onRowDragStart($event, index);
                },
                "dragend": _vm.onRowDragEnd
              }
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "color": "grey darken-1"
              }
            }, [_vm._v(" mdi-drag-vertical ")])], 1)] : header.type == 'actions' ? _c('div', {
              staticClass: "actions"
            }, [header.actions ? _vm._l(header.actions, function (action) {
              return _c('CellAction', {
                key: action.action,
                attrs: {
                  "icon": action.icon,
                  "type": action.type,
                  "label": action.label,
                  "color": action.color,
                  "disabled": action.disabled,
                  "placeholder": action.placeholder
                },
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    return _vm.handleAction(action, item);
                  }
                }
              });
            }) : _vm._e()], 2) : header.value == 'data-table-select' ? [!_vm.selectableKey || item[_vm.selectableKey] ? _c('v-checkbox', {
              key: "".concat(item.id, "-").concat(_vm.isSelected(item)),
              staticClass: "mt-0 pt-0",
              attrs: {
                "hide-details": "",
                "single-line": "",
                "outlined": "",
                "dense": "",
                "input-value": _vm.isSelected(item) || _vm.alreadySelectedFunc(item)
              },
              on: {
                "click": function click($event) {
                  $event.stopPropagation();
                },
                "change": function change($event) {
                  return _vm.toggleItem(item, $event);
                }
              }
            }) : _vm._e()] : header.type == 'getactions' ? _c('div', {
              staticClass: "actions"
            }, _vm._l(header.get_actions(item), function (action) {
              return _c('CellAction', {
                key: action.action,
                attrs: {
                  "icon": action.icon,
                  "type": action.type,
                  "label": action.label,
                  "color": action.color,
                  "disabled": action.disabled,
                  "placeholder": action.placeholder
                },
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    return _vm.handleAction(action, item);
                  }
                }
              });
            }), 1) : header.displayIndex ? [_vm._v(_vm._s(index + 1))] : header.type == 'number' ? [_vm._v(_vm._s(_vm.number(_vm.resolve(item, header))))] : header.component ? [_c(header.component, {
              tag: "component",
              attrs: {
                "item": item
              }
            })] : header.type == 'boolean' ? [_c('span', {
              key: _vm.resolve(item, header)
            }, [_vm.resolve(item, header) ? _c('span', [_vm._v(_vm._s(_vm.$translate("yes")))]) : _c('span', [_vm._v(_vm._s(_vm.$translate("no")))])])] : header.type == 'email' ? [_c('a', {
              attrs: {
                "href": "mailto:".concat(_vm.resolve(item, header))
              },
              on: {
                "click": function click($event) {
                  $event.preventDefault();
                }
              }
            }, [_vm._v(_vm._s(_vm.resolve(item, header)))])] : header.subtype == 'euros' || header.type == 'euros' ? [_vm.resolve(item, header) !== null ? [_vm._v(" " + _vm._s(_vm.price(_vm.resolve(item, header))))] : _vm._e()] : header.type == 'months' && _vm.resolve(item, header) ? [_c('span', [_vm._v(" " + _vm._s(_vm.resolve(item, header) > 1 ? _vm.$translate("months", {
              months: _vm.resolve(item, header)
            }) : _vm.$translate("month", {
              months: _vm.resolve(item, header)
            })) + " ")])] : header.type == 'percentage' || header.type == 'percent' ? [_vm.resolve(item, header) !== null ? [_vm._v(" " + _vm._s(_vm.percent(_vm.percentValue(_vm.resolve(item, header)))) + " ")] : [_c('em', {
              staticClass: "tableplaceholder"
            }, [_vm._v("-")])]] : _vm.resolve(item, header) !== null ? [_vm._v(_vm._s(_vm.resolve(item, header)))] : header.placeHolder ? [_c('em', {
              staticClass: "tableplaceholder"
            }, [_vm._v(_vm._s(header.placeHolder))])] : _vm._e()];
          }, {
            "row": item,
            "header": header,
            "rowIndex": index,
            "value": _vm.resolve(item, header.field)
          })], 2);
        }), 0)];
      }
    }], null, true)
  }, 'v-data-table', _vm.remoteServerBind, false), [_vm.summaryTotals ? _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticClass: "table-summary-row"
  }, _vm._l(_vm.headers, function (header, hi) {
    return _c('td', {
      key: 'summary-' + header.value,
      "class": ['mb-0 mb-sm-0', header["class"], {
        'table-compact-select-cell': _vm.compactSelection && header.value === 'data-table-select',
        'table-compact-action-cell': _vm.compactSelection && _vm.showSelect && ['catalog_entry_add', 'product_add', 'order_line_remove'].includes(header.field)
      }, {
        'table-bordered-cell': _vm.bordered,
        'table-cell-wrap': header.cellWrap === true
      }],
      style: _vm.tdColumnStyle(header)
    }, [hi === _vm.summaryLabelColumnIndex && _vm.summaryTotals._firstCell ? _c('strong', [_vm._v(" " + _vm._s(_vm.summaryTotals._firstCell) + " ")]) : _vm.hasSummarySlot(header) ? _vm._t('summary-' + (header.slot || header.value), null, {
      "header": header,
      "summaryTotals": _vm.summaryTotals
    }) : _vm.summaryCellText(header) !== null ? [_vm._v(" " + _vm._s(_vm.summaryCellText(header)) + " ")] : _vm._e()], 2);
  }), 0)]) : _vm._e()], 2) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }